import { get, put, post, del } from './connection'

const API_BASE_URL = process.env.REACT_APP_API_URL;
const dashboardApi = {  

    getAllStagesWithUsers: async () => {
        try {
            const response = get(`/dashboard/get-all-stages-with-users`);
           return response;
        } catch (error) {
            throw new Error("Error while fetching stages with users");
        }
    }, 
    getRepairOrdersForToday: async (data ) => {
        try {
            const response = await get("/import/get-repairoders-for-today");
           return response;
        } catch (error) {
            throw new Error("Error while fetching imported order details");
        }
    },
    uploadFile: async (requestData) => {
        try {
            const response = await post(`/import/upload`, requestData.formData,'form');
            return response.data;
        } catch (error) {
          throw new Error("File upload failed");
        }
      },
      
    createorupdaterotaskschedule: async (requestData) => {
        try {
            const response = await post(`/dashboard/create-or-update-ro-task-schedule`, requestData);
            return response;
        } catch (error) {
            throw new Error("Error while updating new rotask schedule");
        }
    },

    getRepairOrderStatusCount: async (dateValue) => {
        try {
            const value = `/${dateValue}`
            const response = get(`/dashboard/get-ro-status-count${value}`);
           return response;
        } catch (error) {
            throw new Error("Error while fetching RO status count");
        }
    }, 

    gettechniciandailyschedules: async (dateValue) => {
        try {
            const value = `/${dateValue}`
            const response = get(`/dashboard/get-technician-daily-schedules${value}`);
           return response;
        } catch (error) {
            throw new Error("Error while fetching stages with users");
        }
    },
    updateRoTaskScheduleStatus: async (requestData) => {
        try {
            const response = await post(`/dashboard/update-ro-task-status`, requestData);
            return response;
        } catch (error) {
            throw new Error("Error while updating new rotask schedule");
        }
    },
    getRoTaskHistory: async (data ) => {
        try {
            const response = await get(`/dashboard/get-repair-order-task-history/${data}`);
           return response;
        } catch (error) {
            throw new Error("Error while fetching history");
        }
    },
    updateRepairOrderStatusToCompleted: async (requestData) => {
        try {
            const response = await post(`/dashboard/update-repair-order-status-to-completed`, requestData);
            return response;
        } catch (error) {
            throw new Error("Error while updating new rotask schedule");
        }
    },
    updateRepairOrderTaskScheduleItemStatus: async (requestData) => {
        try {
            const response = await post(`/dashboard/update-ro-task-schedule-item-status`, requestData);
            return response;
        } catch (error) {
            throw new Error("Error while updating RepairOrderTaskScheduleItemStatus");
        }
    },
    updateRepairOrderTaskScheduleItemPrevioudDayStatus: async (requestData) => {
        try {
            const response = await post(`/dashboard/update-ro-task-schedule-item-previous-day-status`, requestData);
            return response;
        } catch (error) {
            throw new Error("Error while updating RepairOrderTaskScheduleItemStatus");
        }
    },
    getRepairORder: async (id) => {
        try {
           const response = get(`/dashboard/get-repair-order-by-id/${id}`);
           return response;
        } catch (error) {
            throw new Error("Error while fetching repair order");
        }
    }
};

export default dashboardApi;